import { render } from "./AddSliderProductHome.vue?vue&type=template&id=bdb4a0c2&scoped=true"
import script from "./AddSliderProductHome.vue?vue&type=script&lang=js"
export * from "./AddSliderProductHome.vue?vue&type=script&lang=js"

import "./AddSliderProductHome.vue?vue&type=style&index=0&id=bdb4a0c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdb4a0c2"]])

export default __exports__